import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (href: string) => {
    navigate(href);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-fire-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                kaiyun体育
              </span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-5 max-w-xs">
              您的全球体育赛事伙伴。提供最全面、最及时、最专业的体育资讯与赛事直播服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-video-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 tracking-wide">服务项目</h4>
            <ul className="space-y-3">
              {['赛事资讯', '赛事直播', '数据分析', '专家解读', '社区互动'].map((item) => (
                <li key={item}>
                  <a
                    href="/category/football"
                    onClick={(e) => { e.preventDefault(); handleNavClick('/category/football'); }}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 tracking-wide">关于我们</h4>
            <ul className="space-y-3">
              {['品牌介绍', '发展历程', '口碑荣誉', '加入我们', '联系我们'].map((item) => (
                <li key={item}>
                  <a
                    href="/about"
                    onClick={(e) => { e.preventDefault(); handleNavClick('/about'); }}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 tracking-wide">帮助支持</h4>
            <ul className="space-y-3">
              {['常见问题', '用户协议', '隐私政策', '免责声明', '意见反馈'].map((item) => (
                <li key={item}>
                  <a
                    href="/about"
                    onClick={(e) => { e.preventDefault(); handleNavClick('/about'); }}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2024 kaiyun体育 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors">服务条款</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}